import "./index.scss"
export function ProgressLine(props) {
  const { fill } = props;
  return (
    <div className={"dp__progress--container"}>
      <div className={"dp__progress--fill"} style={{ width: `${fill}%` }} />
    </div>
  );
}
